import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../../colorVars';
import { Body4 } from '../../../../../../../atomic/text/Text';
import style from './SimpleCandleBreakIndicator.module.css';

type Props = {
  size: number;
  scaleY: (value: number) => number;
  portalRef: {
    current: any;
  };
};

export const SimpleCandleBreakIndicator = observer(
  ({ size, scaleY, portalRef }: Props) => {
    const tradePlanForm: TradePlanData | null = useTradePlanFormStore() ?? null;
    if (!tradePlanForm) return null;
    const candleBreakDetails = tradePlanForm.entryTactics.CANDLE_BREAK;
    const candleDuration = candleBreakDetails.candleDuration;
    return (
      <foreignObject x={120} y={0} width={size - 120} height={20}>
        <div className={style.container}>
          <Body4
            color={colors.lightGrey}
          >{`Setup: Break of ${candleDuration}m candle.`}</Body4>
        </div>
      </foreignObject>
    );
  }
);
